// extracted by mini-css-extract-plugin
export var container = "_w-0";
export var disabled = "_w-4";
export var fullWidth = "_w-3";
export var lined = "_w-1";
export var selected = "_w-5";
export var tab = "_w-2";